import fetchData from './fetchData'
import { parseJSON, checkHttpStatus } from '../shared/utils'
import config from '../config/index'

async function userGetCount(params, payload) {
  const { search } = params

  return fetchData(
    `${config.api.baseUrl}?class=user&action=getcount&search=${search || ''}`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function userGetPage(params, payload) {
  const {
    current, pageSize, search, sort, order,
  } = params

  return fetchData(
    `${config.api.baseUrl}?class=user&action=getpage&current=${current}&pageSize=${pageSize}&sort=${sort}&order=${order}&search=${search || ''}`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function userCreate(payload) {
  return fetchData(
    `${config.api.baseUrl}?class=user&action=create`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function userRead(values, payload) {
  const { id } = values

  return fetchData(
    `${config.api.baseUrl}?class=user&action=read&id=${id}`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function userUpdate(payload) {
  return fetchData(
    `${config.api.baseUrl}?class=user&action=update`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function userDelete(values, payload) {
  const { id } = values

  return fetchData(
    `${config.api.baseUrl}?class=user&action=delete&id=${id}`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}


async function userGetSellerMenu(payload) {
  return fetchData(
    `${config.api.baseUrl}?class=user&action=getSellerMenu`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function userUpdateSellerMenu(payload) {
  return fetchData(
    `${config.api.baseUrl}?class=user&action=updateSellerMenu`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

export {
  userGetCount,
  userGetPage,
  userCreate,
  userRead,
  userUpdate,
  userDelete,
  userGetSellerMenu,
  userUpdateSellerMenu,
}



// WEBPACK FOOTER //
// src/api/user.js